<template>
	<md-field class="form-group">
		<label v-bind:for="input.url" class="form-control-placeholder">{{ label }}</label>

		<i class="fa fa-spinner fa-spin" v-if="loading"></i>
		<template v-else>
			<i class="fa fa-times" v-show="isDirty" @click="reset"></i>
		</template>

		<md-input v-bind:id="input.url" type="text"
				  disabled="disabled == true"
				  class="Typeahead__input"
				  autocomplete="off"
				  v-model="query"
				  @keydown.down="down"
				  @keydown.up="up"
				  @keydown.enter="hit"
				  @keydown.esc="reset"
				  @input="update">
		</md-input>

		<div class="search-typeahead" v-show="hasItems">
			<ul>
				<li v-for="(item, $item) in items" class="activeClass($item)" @mousedown="hit" @mousemove="setActive($item)">
					<span class="name">{{ item.Name }}</span>
				</li>
			</ul>
		</div>
		<div v-if="items.length === 0 && query.length > 2" class="search-typeahead">
			<ul><li><span>No results found</span></li></ul>
		</div>
	</md-field>
</template>

<script>
	import VueTypeahead from 'vue-typeahead';

	export default {
		extends: VueTypeahead,
		props: {
			input: {
					type: String,
					default: () => ''
			},
			name: {
					type: String,
					default: () => ''
			},
			list: {
					type: Array,
					default: () => []
			},
			disabled: {
					type: Boolean,
					default: () => false
			},
			label: {
					type: String,
					default: () => ''
			},
		},
		data: function() {
			return  {
				src: this.fetch(),
				limit: 6,
				minChars: 2,
				query: '',
				filter: {
					Name: '',
					Value: '',
				},
			}
		},
		watch: {
			input: {
				handler(newVal){
					if (newVal === ''){
						this.query = newVal;
					}
				},
				deep: true
			},
			list: {
				handler(newVal){
					this.list = newVal;
				},
				deep: true
			},
			disabled: {
				handler(newVal){
					this.disabled = newVal;
				}
			},
			isEmpty: function(newVal) {
				this.filter.Value = '';
				this.filter.Name = this.name;
				this.$emit('typeaheadselected', this.filter);
			},
		},
		methods: {
			fetch () {
				let _this = this;

				return Promise.resolve({
					data: _this.list.filter((item) => {
						return item.Name.toLowerCase().indexOf(this.query.toLowerCase()) != -1
					})
				})
			},
			onHit (item) {
				this.query = item.Name;

				this.filter.Value = item.Value;
				this.filter.Name = this.name;

				this.$emit('typeaheadselected', this.filter);
			}
		}
	}
</script>

<style scoped>
	.fa-times {
		cursor: pointer;
	}

	i {
		position: absolute;
		top: 15px;
		right: 20px;
		opacity: 0.4;
	}
</style>